import { tss } from 'tss-react/mui';

export const useDesignStyles = tss.create(({ theme }) => ({
  choice: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    textAlign: 'start',
    justifyContent: 'start',
    alignItems: 'stretch',
    flexDirection: 'column',
    gap: theme.spacing(1),
    border: `1px solid ${theme.palette.border.default}`,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    '&[aria-pressed="true"]': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
    '&.Mui-focusVisible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  navButton: {
    width: '100%',
    minWidth: 0,
    minHeight: 40,
    fontSize: 12.5,
    fontWeight: 450,
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    justifyContent: 'start',
    '&&': { color: theme.palette.text.secondary, backgroundColor: 'transparent' },
    '&&[aria-current="page"]': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
      fontWeight: 600,
    },
    '&:hover': { backgroundColor: theme.palette.action.hover, color: theme.palette.text.primary },
  },
  compactButton: {
    '&&': {
      padding: theme.spacing(1, 0.25),
      gap: theme.spacing(0.5),
      fontSize: 9.5,
      lineHeight: 1.2,
      minHeight: 48,
    },
    '& svg': { flexShrink: 0 },
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: 9.5,
    lineHeight: 1.2,
  },
  workspace: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    minWidth: 0,
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.border.subtle}`,
    borderRadius: theme.shape.borderRadius,
  },
  miniScene: {
    height: 64,
    display: 'flex',
    width: '100%',
    border: `1px solid ${theme.palette.border.subtle}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    backgroundColor: theme.palette.surface.sunken,
  },
}));
